<h4>Previously Assigned Commission</h4>
@if (assignedCommisionList != undefined && assignedCommisionList.length > 0) {
  <table class="table table-boredered table-custom">
    <thead>
      <tr>
        <th></th>
        <th>Date</th>
        <th>Amount (Balance/Total)</th>
        <th>Assignee</th>
      </tr>
    </thead>

    <tbody>
      @for (comm of assignedCommisionList; track comm; let i = $index) {
        <tr>
          <td>
            @if (isAssignedByLoggedInUser(comm) == true) {
              <button class="btn btn-warning" (click)="openEditCommissionModal(comm)">
                <i class="fas fa-pencil-alt"></i>
              </button>
              <button class="btn btn-danger" (click)="confirmBeforeDeletingCommission(comm, i)">
                <i class="fas fa-trash-alt"></i>
              </button>
            }
          </td>
          <td>{{ comm.DateCreated | date: "dd-MM-yyyy" }}</td>
          <td>RM{{ comm.Amount - comm.Paid }} / RM {{ comm.Amount }}</td>
          <td>{{ comm.Assignee }}</td>
        </tr>
      }
    </tbody>
  </table>
} @else {
  <p class="fw-bold text-danger">This loan do not have any assigned commission.</p>
}
